<template>
  <div :class="classes">
    <div class="new-version__content">
      <img
        :src="assetsPath('logo.svg')"
        :alt="str('global.title')"
        class="new-version__img"
      />
      <p class="new-version__text">
        {{ str('global.updateApp') }}
      </p>
      <div class="new-version__spinner"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'new-version',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classes: function () {
        let classes = ['new-version']
        if (this.visible) {
          classes.push('new-version--visible')
        }
        return classes.join(' ')
      },
    },
  }
</script>

<style lang="scss">
  .new-version {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: $overlay-color;
    opacity: 0;
    transition: opacity 0.8s ease 0s;

    &--visible {
      opacity: 1;
      z-index: 100;
    }

    &__content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      line-height: $line-height-sm;
      max-width: 400px;
      transition: $transition-base;

      @media (min-width: $bp-md) {
        font-size: $font-size-lg;
      }
    }

    &__img {
      max-width: 150px;
      margin-bottom: spacer(1);

      @media (min-width: $bp-md) {
        max-width: 200px;
        margin-bottom: spacer(3);
      }
    }

    &__text {
      margin-bottom: spacer(1);

      @media (min-width: $bp-md) {
        margin-bottom: spacer(2);
      }
    }

    &__spinner {
      width: spacer(3);
      height: spacer(3);
      margin-left: auto;
      margin-right: auto;
      border: 3px solid $community;
      border-top-color: transparent;
      border-radius: 100%;
      animation: spin 1.8s linear 0s infinite;
    }
  }
</style>
